import { createReducer, on } from '@ngrx/store';

import * as actions from './reference.actions';

export const REFERENCE_FEATURE_KEY = 'reference';

export interface ReferenceState {
  countries: string[];
  industries: string[];
  isLoading: boolean;
}

export const initialState: ReferenceState = {
  countries: [],
  industries: [],
  isLoading: false,
};

export const referenceReducer = createReducer(
  initialState,
  on(actions.getCountries, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getCountriesSuccess, (state, { countries }) => ({
    ...state,
    countries,
    isLoading: false,
  })),
  on(actions.getCountriesFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(actions.getIndustries, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.getIndustriesSuccess, (state, { industries }) => ({
    ...state,
    industries,
    isLoading: false,
  })),
  on(actions.getIndustriesFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
);
